import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  text?: string;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'md',
  className,
  text,
}) => {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-6 w-6',
    lg: 'h-8 w-8',
  };

  return (
    <div className={cn('flex flex-col items-center gap-2', className)}>
      <Loader2
        className={cn('animate-spin text-muted-foreground', sizeClasses[size])}
      />
      {text && <span className='text-sm text-muted-foreground'>{text}</span>}
    </div>
  );
};

// Specialized loading components for different contexts
export const PageLoader = ({ text = 'Loading...' }: { text?: string }) => (
  <div className='flex items-center justify-center min-h-[400px]'>
    <LoadingSpinner size='lg' text={text} />
  </div>
);

export const InlineLoader = ({ text }: { text?: string }) => (
  <div className='flex items-center justify-center py-4'>
    <LoadingSpinner size='sm' text={text} />
  </div>
);

export const FullPageLoader = ({
  text = 'Loading PLSOM Admin...',
}: {
  text?: string;
}) => (
  <div className='min-h-screen flex items-center justify-center'>
    <div className='text-center'>
      <LoadingSpinner size='lg' className='mb-4' />
      <div>
        <h3 className='font-semibold mb-1'>{text}</h3>
        <p className='text-sm text-muted-foreground'>
          Please wait while we set up your workspace
        </p>
      </div>
    </div>
  </div>
);
